import $ from 'jquery'
import Mask from 'vanilla-masker'

export function maskText ($elements) {
  $elements.each((index, elem) => {
    applyMask(elem)
  })
}

const applyMask = (element) => {
  const $element = $(element)
  const text = $element.text()

  if (text) {
    let maskedText, maskPattern
    const maskType = $element.attr('data-mask-text').toLowerCase()

    switch (maskType) {
      case 'money':
        maskedText = Mask.toMoney(text, { unit: 'R$' })
        break
      case 'number':
        maskedText = Mask.toNumber(text)
        break
      case 'phone':
        maskPattern = setPhoneMask(text)
        break
      case 'cpf':
        maskPattern = '999.999.999-99'
        break
      case 'cnpj':
        maskPattern = '99.999.999/9999-9'
        break
      case 'date':
        maskPattern = '99/99/9999'
        break
      default:
        maskPattern = maskType
        break
    }

    if (!maskedText) {
      maskedText = Mask.toPattern(text, maskPattern)
    }

    $element.text(maskedText)
  }
}

const setPhoneMask = (text) => {
  switch (text.length) {
    case 11:
      return '(99) 99999-9999'

    case 10:
      return '(99) 9999-9999'

    case 9:
      return '99999-9999'

    default:
      return '9999-9999'
  }
}
